module.exports = __webpack_public_path__ + "static/media/CIHF_W250px.7ee1a52c.jpg";